//Hide and show form fields conditionally
var _ = require('lodash');
/*
 * Main class
 */
module.exports = {
  /**
  * This function is used to initialize this plugin for a given dom element
  * @param {Object} $this DOM Element to which this plugin will be initialized to.
  * @returns {Object} DOM Element on which the module was applied
  */
  initialize: function _initialize($this) {
    var _self = this;
    _self.defineGlobalVariables($this);
    if (_self.countriesList.length) {
      _self.toggleFormElements(_self.selectedValue);
    }
    else {
      _self.phoneNumber.removeClass("l-display-none");
      _self.postalCode.addClass("l-display-none");
      _self.countryPrefixCode.removeClass("l-display-none");
      // To handele form fields other than CN country
      if(_self.isMobileVerificationRequired()){
        _self.otpFlowToggleText.hide();
        _self.otpFlowHideText.show();
        _self.otpFlowToggle.prop('disabled',false).removeClass('is-disabled');
        _self.fieldPassword.prop('disabled',false).removeClass('is-disabled');
      }
    }
    // Using global reference of jquery so that events on custom select box work correctly
    $($this.find('.js-countries-list')).on('change', _self.toggleCountryFields.bind(_self));
    return $this;
  },
  /**
  * This function is used to declare the variables to be used globally
  * @param {Object} $this DOM Element to which this plugin will be initialized to.
  * @returns {boolean} Operation succeeded or not
  */
  defineGlobalVariables: function _defineGlobalVariables($this) {
    var _self = this;
    _self.countryNewEnrollment = $this.find(".js-newEnrollment-country");
    _self.countriesList = $this.find(".js-countries-list");
    _self.selectedValue = _self.countriesList.find("option:selected").val();
    _self.postalCode = $this.find(".js-postal-code");
    _self.phoneNumber = $this.find(".js-mobile-number");
    _self.countryPrefixCode = $this.find(".js-country-prefix-code");
    _self.countryMapping = _self.countriesList.data("mapping");
    _self.isSweapStakes = $this.find('input[name="isSweapStakes"]').val();
    //Declaring toggle form fields    
    _self.otpFlowToggle = $('.js-otp-flow-toggle');
    _self.otpFlowToggleText = $('.js-otp-flow-toggle-text');
    _self.otpFlowHideText = $('.js-otp-flow-hide-text');
    _self.fieldPassword = $this.find(".js-otp-flow-toggle-pwd");    
    _self.confirmPasswordIcon = $this.find('.js-confirm-password-icon');
    _self.passwordInfo = $this.find(".js-password-info li");
    _self.passwordInfoIcon = $this.find(".js-password-info li span.t-icon");
    _self.passwordIcon = $this.find(".js-password-icon");
    _self.oneTimeCodeToggle = $this.find('.js-field-one-time-code');
    _self.otpFlowDisableCheckbox = $this.find('.js-otp-flow-disable-checkbox');
    _self.otpFlowDisableBtn = $this.find('.js-otp-flow-disable-btn');
    _self.resendCode = $this.find('.js-resend-code');    
    _self.mobileVerificationRequiredFlag = $this.find('.js-mobile-verification-required');
    _self.otpTransactionId = $this.find('.js-otp-transactionId');
    _self.otpFlowToggleClear = $this.find('.js-otp-flow-toggle-clear');
    return true;
  },
 /**
  * This function is used to pass the necessary values to the zipcode and select field methods
  * @returns {boolean} Operation succeeded or not
  */
  toggleCountryFields: function _toggleCountryFields() {
    var _self = this,
      countrySelected = _self.countriesList.find("option:selected").val();
    _self.selectedDropDownValue(countrySelected);
    _self.toggleFormElements(countrySelected);
    _self.selectedDropDownCountryCode(countrySelected);
    return true;
  },
  /**
  * This function is used to toggle the zipcode/postal field based on the selected country
  * @param {string} countrySelected Value of the selected country from the dropdown
  * @returns {boolean} Operation succeeded or not
  */
  toggleFormElements: function _toggleFormElements(countrySelected){
    var _self = this,
    selectedCountryPrefixCode = _self.countryPrefixCode.find('input[name="countryPrefixCode"]').val();
    if(_.includes(_self.countryMapping.postalRequired, countrySelected)) {
      _self.postalCode.removeClass("l-display-none");
      _self.countryNewEnrollment.removeClass("l-l-col-12");
      _self.countryNewEnrollment.addClass("l-l-col-6");
      if(_self.isSweapStakes == "false") {
        _self.phoneNumber.addClass("l-display-none");
        _self.countryPrefixCode.addClass("l-display-none");
      }
      // To handele form fields other than CN country
      if(_self.isMobileVerificationRequired()){
        _self.otpFlowToggleText.hide();
        _self.otpFlowHideText.show();
        _self.otpFlowToggle.prop('disabled',false).removeClass('is-disabled');
        _self.fieldPassword.prop('disabled',false).removeClass('is-disabled');
      }      
    } else if(_.includes(_self.countryMapping.phoneRequired, countrySelected)) {
        _self.phoneNumber.removeClass("l-display-none");
        _self.postalCode.addClass("l-display-none");
        _self.countryPrefixCode.removeClass("l-display-none");
        _self.countryNewEnrollment.removeClass("l-l-col-6");
        _self.countryNewEnrollment.addClass("l-l-col-12");
        //checking for CN domain and enabling the form fields
        if(_self.isMobileVerificationRequired()){
          if(_.includes(_self.countryMapping.phoneRequired, selectedCountryPrefixCode)){
            if(_self.otpTransactionId.val() == ''){
              _self.otpFlowToggleText.show();
              _self.otpFlowHideText.hide();
              _self.otpFlowToggle.prop("disabled",true).addClass('is-disabled');
              _self.otpFlowToggleClear.prop('disabled',true).addClass('is-disabled').val('').removeClass("is-error");              
              _self.passwordInfo.removeClass('t-form-success').addClass('t-form-error');
              _self.passwordInfoIcon.removeClass('t-icon-check').addClass('t-icon-cross');
              _self.passwordIcon.removeClass('t-icon-check t-icon-cross');
              _self.confirmPasswordIcon.removeClass('t-icon-check t-icon-cross');              
              _self.otpFlowDisableCheckbox.prop('checked',false);
              _self.otpFlowDisableBtn.prop("disabled", true).addClass('is-disabled t-cursor-default');
              _self.resendCode.addClass('l-resend-code');                                                                         
            }
            else{
              _self.otpFlowToggleText.show();
              _self.otpFlowHideText.hide();
              _self.otpFlowToggle.prop("disabled",false).removeClass('is-disabled');                           
              _self.fieldPassword.prop("disabled",false).removeClass('is-disabled');
              _self.otpFlowDisableCheckbox.prop('checked',false);
              _self.otpFlowDisableBtn.prop("disabled", true).addClass('is-disabled t-cursor-default'); 
              _self.resendCode.removeClass('l-resend-code');                                                           
            }          
          } else {
            _self.otpFlowToggleText.hide();
            _self.otpFlowHideText.show();
            _self.otpFlowToggle.prop('disabled',false).removeClass('is-disabled');
            _self.fieldPassword.prop('disabled',false).removeClass('is-disabled');
          }
      }
    } else if(_.includes(_self.countryMapping.countryPrefixCodeRequired, countrySelected)) {
      _self.postalCode.removeClass("l-display-none");
      if(_self.isSweapStakes == "false") {
        _self.phoneNumber.addClass("l-display-none");
        _self.countryPrefixCode.addClass("l-display-none");
      }
      // To handele form fields other than CN country
      if(_self.isMobileVerificationRequired()){
        _self.otpFlowToggleText.hide();
        _self.otpFlowHideText.show();
        _self.otpFlowToggle.prop('disabled',false).removeClass('is-disabled');
        _self.fieldPassword.prop('disabled',false).removeClass('is-disabled');
      }
    }
    else {
      _self.postalCode.addClass("l-display-none");
      _self.countryNewEnrollment.removeClass("l-l-col-6");
      _self.countryNewEnrollment.addClass("l-l-col-12");     
      _self.postalCode.find('input.postal-code').val('');
      if(_self.isSweapStakes == "false") {
        _self.phoneNumber.addClass("l-display-none");
        _self.countryPrefixCode.addClass("l-display-none");
      }
      // To handele form fields other than CN country
      if(_self.isMobileVerificationRequired()){
        _self.otpFlowToggleText.hide();
        _self.otpFlowHideText.show();
        _self.otpFlowToggle.prop('disabled',false).removeClass('is-disabled');
        _self.fieldPassword.prop('disabled',false).removeClass('is-disabled');
      }
    }
    return true;
  },
  /**
  * This function is used to populate the country field with the selected value
  * @param {string} selectedValue Value of the selected country from the dropdown
  * @returns {boolean} Operation succeeded or not
  */
  selectedDropDownValue: function _selectedDropDownValue(selectedValue){
    this.countriesList.find("option[value='"+ selectedValue +"']").attr("selected","selected");
  },
  /**
  * This function is used to populate the country code with the selected value
  * @param {string} selectedValue Value of the selected country code from the dropdown
  * @returns {boolean} Operation succeeded or not
  */
  selectedDropDownCountryCode: function _selectedDropDownCountryCode(selectedValue){
    var _self = this;
    if(_self.isSweapStakes == "true") {
      _self.phoneNumber.removeClass("l-display-none");
      _self.countryPrefixCode.removeClass("l-display-none");
      _self.countryPrefixCode.find("#mobilePhoneDropdownList").val(selectedValue);
    }
    _self.countryPrefixCode.find(".selectric-items li").removeClass('highlighted');
    _self.countryPrefixCode.find(".selectric-items li[value='"+ selectedValue +"']").addClass('highlighted');
    var countryCodeSelected = _self.countryPrefixCode.find(".mobilePhoneDropdownList li[value='"+ selectedValue +"'] span").text();
    _self.countryPrefixCode.find("#mobile-telephone").text(countryCodeSelected);
  },
  // To check Mobile Verification Required
  isMobileVerificationRequired: function _isMobileVerificationRequired() {
    var _self = this;
    var mobileVerificationRequiredCheck = _self.mobileVerificationRequiredFlag.data('mobile-verification-refuired');
    return mobileVerificationRequiredCheck;
  }
};
